import { MemberCorpoInfo } from 'domain/entities/UserEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompanyForm } from './components/CompanyForm';
import { NoDataForm } from './components/NoDataForm';

const CU00703Page = (props: AppProps) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [data, setData] = React.useState<MemberCorpoInfo>();

    const { userUseCase } = props;

    useEffect(() => {
        (async () => {
            await initiateDefaultData();
        })();
    }, []);

    const initiateDefaultData = async () => {
        try {
            dispatch(startFetching());
            const response = await userUseCase.getMemberCorproInfo();

            if (response && response.result) {
                const mappingData = {
                    ...response.result,
                    email: response.result?.memberAccount?.email ?? '',
                    nickName: response.result?.memberBasic?.nickname ?? '',
                };
                setData(mappingData);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const goToCreatePage = () => {
        navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.CU_006_01);
    };

    const render = () => {
        if (data?.memberAccountId) {
            return (
                <div className="section-wrapper">
                    <CompanyForm data={data} />
                </div>
            );
        } else {
            return (
                <div className="section-wrapper h-full">
                    <NoDataForm editClick={goToCreatePage} />
                </div>
            );
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-006-01-container"
        >
            <PageTitle title="会員情報の確認・編集" />
            <section
                style={{
                    padding: '0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="corpo-form-container w-full">
                    {render()}
                </div>
            </section>
        </div>
    );
};

export default CU00703Page;
